import script from "./ImportOrderCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportOrderCustomer.vue?vue&type=script&setup=true&lang=js"

import "./ImportOrderCustomer.vue?vue&type=style&index=0&id=332e55b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-332e55b8"]])

export default __exports__